__turbopack_context__.v({
  "badge": "TechSliderSection-module___CtktW__badge",
  "badgeLabel": "TechSliderSection-module___CtktW__badgeLabel",
  "card": "TechSliderSection-module___CtktW__card",
  "desc": "TechSliderSection-module___CtktW__desc",
  "dot": "TechSliderSection-module___CtktW__dot",
  "dotActive": "TechSliderSection-module___CtktW__dotActive",
  "dots": "TechSliderSection-module___CtktW__dots",
  "eyebrow": "TechSliderSection-module___CtktW__eyebrow",
  "head": "TechSliderSection-module___CtktW__head",
  "logo": "TechSliderSection-module___CtktW__logo",
  "nav": "TechSliderSection-module___CtktW__nav",
  "navLeft": "TechSliderSection-module___CtktW__navLeft",
  "navRight": "TechSliderSection-module___CtktW__navRight",
  "section": "TechSliderSection-module___CtktW__section",
  "subtitle": "TechSliderSection-module___CtktW__subtitle",
  "title": "TechSliderSection-module___CtktW__title",
  "topBar": "TechSliderSection-module___CtktW__topBar",
  "track": "TechSliderSection-module___CtktW__track",
  "viewport": "TechSliderSection-module___CtktW__viewport",
});
